import { DateTime } from 'luxon';

export enum DATE_FORMAT {
  MONTH = 'LLLL',
  DAY = 'dd',
  DATE = 'dd LLLL yyyy',
  SLACH_DATE = 'dd/LL/yyyy',
  DAY_MONTH = 'dd LLL',
  FULL_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZ",
  DATE_TIME = "dd LLLL yyyy à HH'h'mm",
}

export const DisplayDate = (date: string) => {
  return DateFromString(date, DATE_FORMAT.DATE);
};

export const DisplayDateTime = (date: string) => {
  return DateFromString(date, DATE_FORMAT.DATE_TIME);
};

export const DateFromString = (
  date: string,
  format = DATE_FORMAT.DATE_TIME
): string => {
  return DateTime.fromISO(date).setLocale('fr').toFormat(format);
};
